import React, { useMemo } from 'react';
import { useGoals } from '../../contexts/GoalContext';
import { useLast10 } from '../../contexts/Last10Context';

const FinishModeBanner = () => {
    const { goals } = useGoals();
    const { isInLast10 } = useLast10();

    // Calculate how many goals are eligible for Finish Mode
    const finishModeEligibleGoals = useMemo(() => {
        if (!goals || !Array.isArray(goals)) return [];

        return goals.filter(goal => {
            if (!goal || goal.status === 'completed') return false;

            // Check if goal is in Last 10% using the context helper
            // First, we need the progress info - check if it has last10EnteredAt
            return goal.last10EnteredAt && goal.status !== 'completed' && !goal.completedFromLast10;
        });
    }, [goals]);

    // Don't show banner if no goals are eligible
    if (finishModeEligibleGoals.length === 0) {
        return null;
    }

    return (
        <div className="mb-4 p-4 rounded-lg border-l-4 border-amber-500 bg-amber-50 dark:bg-amber-900/20 shadow-sm">
            <div className="flex items-start gap-3">
                <div className="flex-shrink-0 pt-0.5">
                    <svg
                        className="w-5 h-5 text-amber-600 dark:text-amber-400 animate-pulse"
                        fill="currentColor"
                        viewBox="0 0 20 20"
                        aria-hidden="true"
                    >
                        <path fillRule="evenodd" d="M8.257 3.099c.765-1.36 2.722-1.36 3.486 0l5.58 9.92c.75 1.334-.213 2.98-1.742 2.98H4.42c-1.53 0-2.493-1.646-1.743-2.98l5.58-9.92zM11 13a1 1 0 11-2 0 1 1 0 012 0zm-1-8a1 1 0 00-1 1v3a1 1 0 002 0V6a1 1 0 00-1-1z" clipRule="evenodd" />
                    </svg>
                </div>
                <div className="flex-1">
                    <h3 className="font-semibold text-amber-900 dark:text-amber-100 text-sm">
                        Goal{finishModeEligibleGoals.length > 1 ? 's' : ''} Nearing Completion
                    </h3>
                    <p className="text-sm text-amber-800 dark:text-amber-200 mt-1">
                        You have {finishModeEligibleGoals.length} goal{finishModeEligibleGoals.length > 1 ? 's' : ''} in the final phase.
                        {' '}
                        <span className="font-medium">
                            Consider entering Finish Mode to complete {finishModeEligibleGoals.length > 1 ? 'them' : 'it'} strong.
                        </span>
                    </p>
                </div>
                <div className="flex-shrink-0">
                    <div className="inline-flex items-center justify-center h-6 w-6 rounded-full bg-amber-200 dark:bg-amber-800">
                        <span className="text-xs font-bold text-amber-900 dark:text-amber-100">
                            {finishModeEligibleGoals.length}
                        </span>
                    </div>
                </div>
            </div>
        </div>
    );
};

export default FinishModeBanner;
